// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';

//HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";


// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";

interface ServicesProps {
    agencyId: number;
}

const Services: React.FC<ServicesProps> = ({agencyId}) => {

    const { t } = useTranslation();

    const { agency } = useGetAgencyDetails(agencyId);

    const servicesList = [
        {
            image: "/assets/images/altrePag/service1.png",
            title: t('servicesPage.service1Title') as string,
            description: t('servicesPage.service1Description') as string
        },
        {
            image: "/assets/images/altrePag/service2.jpg",
            title: t('servicesPage.service2Title') as string,
            description: t('servicesPage.service2Description') as string
        },
        {
            image: "/assets/images/altrePag/service3.jpg",
            title: t('servicesPage.service3Title') as string,
            description: t('servicesPage.service3Description') as string
        },
        {
            image: "/assets/images/altrePag/service4.jpg",
            title: t('servicesPage.service4Title') as string,
            description: t('servicesPage.service4Description') as string
        }
    ];
    return (
        <>
            <Helmet>
                <title>{t('servicesPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
            </Helmet>

            <SubHeaderDefault title={t('servicesPage.subHeaderTitle')} isSeo={true} />

            <main id="services-page" className="space-ptb">
                <div className="container-fluid w-special">
                    <h2 dangerouslySetInnerHTML={{ __html: t('servicesPage.title') as string }} className="mb-4" />
                    <div className="row">
                        {servicesList.map((service, index) => (
                            <div key={index} className="col-12 col-lg-6 mb-4">
                                <div className="service-item">
                                    <div className="img-wrapper">
                                        <img src={service.image} alt={service.title} />
                                    </div>
                                    <div>
                                        <h3>{service.title}</h3>
                                        <p>{service.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para1') as string }}></p>
                </div>
            </main>
        </>
    );
};

export default Services;